module.exports = __webpack_public_path__ + "media/images/search_icon-94a727aab49c00f8fcbcec50cece78aa.svg";